/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_ROUTE_PUSH = "DO_ROUTE_PUSH";
export const DO_GET_CA = "DO_GET_CA";
export const DO_GET_CA_SUCCESS = "DO_GET_CA_SUCCESS";
export const DO_GET_CA_ERROR = "DO_GET_CA_ERROR";
export const DO_SET_CA = "DO_SET_CA";
export const DO_SET_CA_SUCCESS = "DO_SET_CA_SUCCESS";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_GET_API = "DO_GET_API";
export const DO_LANDING = "DO_LANDING";
export const DO_PASO1 = "DO_PASO1";
export const DO_PASO1_SUCCESS = "DO_PASO1_SUCCESS";
export const DO_PASO2 = "DO_PASO2";
export const DO_PASO2_SUCCESS = "DO_PASO2_SUCCESS";
export const DO_PASO3 = "DO_PASO3";
export const DO_PASO4 = "DO_PASO4";
export const DO_PASO4_SUCCESS = "DO_PASO4_SUCCESS";
export const DO_PASO_ERROR = "DO_PASO_ERROR";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_CLICK_TRACKING = "DO_CLICK_TRACKING";
export const DO_MOCK = "DO_MOCK";
export const DO_ADOBE_TARGET_EXPERIENCE = "DO_ADOBE_TARGET_EXPERIENCE";

/** Reactivo Web */
export const DO_REACTIVO_PASO1 = "DO_REACTIVO_PASO1";
export const DO_REACTIVO_PASO1_SUCCESS = "DO_REACTIVO_PASO1_SUCCESS";
export const DO_REACTIVO_OFERTA = "DO_REACTIVO_OFERTA";
export const DO_REACTIVO_OFERTA_SUCCESS = "DO_REACTIVO_OFERTA_SUCCESS";
export const DO_REACTIVO_GRACIAS_EXCEDIDO = "DO_REACTIVO_GRACIAS_EXCEDIDO";
export const DO_REACTIVO_GRACIAS_EXCEDIDO_SUCCESS =
  "DO_REACTIVO_GRACIAS_EXCEDIDO_SUCCESS";
export const DO_REACTIVO_GRACIAS_EXCEDIDO_ERROR =
  "DO_REACTIVO_GRACIAS_EXCEDIDO_ERROR";
export const DO_AGRO_ERROR = "DO_AGRO_ERROR";

export const DO_AGRO_PASO_1 = "DO_AGRO_PASO_1";
export const DO_AGRO_PASO_1_VALIDAR_CUIT = "DO_AGRO_PASO_1_VALIDAR_CUIT";
export const DO_AGRO_PASO_1_VALIDAR_CUIT_SUCCESS =
  "DO_AGRO_PASO_1_VALIDAR_CUIT_SUCCESS";
export const DO_AGRO_PASO_2 = "DO_AGRO_PASO_2";
export const DO_AGRO_PASO_3 = "DO_AGRO_PASO_3";
export const DO_AGRO_PASO_3_SUCCESS = "DO_AGRO_PASO_3_SUCCESS";
export const DO_AGRO_PASO_1_VALIDAR_CUIT_ERROR =
  "DO_AGRO_PASO_1_VALIDAR_CUIT_ERROR";
export const DO_AGRO_PASO_3_0 = "DO_AGRO_PASO_3_0";

export const DO_GENERAR_OTP = "DO_GENERAR_OTP";
export const DO_GENERAR_OTP_SUCCESS = "DO_GENERAR_OTP_SUCCESS";
export const DO_GENERAR_OTP_ERROR = "DO_GENERAR_OTP_ERROR";
export const DO_VALIDAR_OTP = "DO_VALIDAR_OTP";
export const DO_VALIDAR_OTP_SUCCESS = "DO_VALIDAR_OTP_SUCCESS";
export const DO_VALIDAR_OTP_ERROR = "DO_VALIDAR_OTP_ERROR";
export const DO_AGRO_CONSULTAR_CULTIVOS = "DO_AGRO_CONSULTAR_CULTIVOS";
export const DO_AGRO_CONSULTAR_CULTIVOS_SUCCESS =
  "DO_AGRO_CONSULTAR_CULTIVOS_SUCCESS";
export const DO_AGRO_CONSULTAR_CULTIVOS_ERROR =
  "DO_AGRO_CONSULTAR_CULTIVOS_ERROR";
export const DO_AGRO_PASO_1_GET_VALIDAR_CUIT =
  "DO_AGRO_PASO_1_GET_VALIDAR_CUIT";
export const DO_AGRO_MOTOR_ERROR = "DO_AGRO_MOTOR_ERROR";
export const DO_ES_CLIENTE = "DO_ES_CLIENTE";
export const DO_ES_CLIENTE_OK = "DO_ES_CLIENTE_OK";
export const DO_CALL_API_ES_CLIENTE = "DO_CALL_API_ES_CLIENTE";
export const DO_ENVIAR_SOLICITUD = "DO_ENVIAR_SOLICITUD";
